import { apiFetch } from '../api'
/* eslint-disable */
export function isUserLoggedIn() {
  if (!localStorage.getItem('authorization')) {
    return false
  } else {
    return true
  }
}

export function logout() {
  apiFetch('POST', '/api/auth/logout', {}, localStorage.getItem('authorization')).then(
    (response) => {
      localStorage.removeItem('user')
      localStorage.removeItem('authorization')
      localStorage.removeItem('selectedMembership')
      localStorage.removeItem('memberships')

      window.location.href = '/'
    },
    (error) => {
      localStorage.removeItem('user')
      localStorage.removeItem('authorization')
      localStorage.removeItem('selectedMembership')
      localStorage.removeItem('memberships')

      window.location.href = '/'
    },
  )
}
